import { render, staticRenderFns } from "./ReservationParents.vue?vue&type=template&id=81f1d708&"
import script from "./ReservationParents.vue?vue&type=script&lang=js&"
export * from "./ReservationParents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports